const LinkChecker = function () {

    const linkChecker = function (e) {
        const element = $(this);
        let url = element.attr('href');

        e.preventDefault();

        if (element.hasClass('export-proposal')) {
            let responseRule = exportProposal(element);
            if (responseRule) {
                // window.location = url;
            }
        }
    }

    const exportProposal = function (element) {
        const val = $('[name="date_interval"]').val();
        const message = element.data('link_checker_message');

        if (val.length == 0) {
            $('#loading-div').fadeToggle(200, function () {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: message
                })
            });

            return false;
        }

        const submit = $('#filter-list').data('submit');
        if (submit === 0) {
            $('#loading-div').fadeToggle(200, function () {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: $('#filter-list').data('message')
                })
            });

            return false;
        }


        return true;
    }

    return {
        init: function () {
            $(document).on('click', '.link-checker', linkChecker);
        }
    }
}();

module.exports = LinkChecker;